import { Slider } from 'ui/components';

export const SliderFeature: React.FC<Content.Slider> = ({ content }) => {
	const { slides } = content?.properties ?? {};

	const mappedSlides = slides.map(({ content }) => {
		const { heading, text } = content?.properties ?? {};

		return {
			heading,
			text,
		};
	});

	return <Slider slides={mappedSlides} />;
};
